export default {
  account_required: "Хэрэглэгчийн нэрээ оруулна уу'",
  password_required: "Нууц үгээ оруулна уу'",
  confirm_password_different: "Нууц үг нь Нууц үгтэй ижил биш гэдгийг баталгаажуулах'",
  min_length: "8 ба түүнээс дээш тэмдэгт байх ёстой",
  alphanumeric_char: "Зөвхөн үсэг тоон тэмдэгтийг хүлээн зөвшөөрдөг.",
  numeric_char: "Зөвхөн тоон тэмдэгтийг хүлээн авна.",
  list:{
    0: "Таны сессийн хугацаа дууссан тул дахин нэвтэрнэ үү.",
    disconnect: "Холболтоо шалгаад дахин оролдоно уу.",
    OK: "Tac кодыг амжилттай илгээсэн // tac код",
    ok: "Tac кодыг амжилттай илгээсэн // tac код",
    CLOSE: "UBWIN-ийн Шударга Тоглоомын Нөхцөлийг зөрчсөний улмаас таны бүртгэлийг хориглосон.",
    close: "UBWIN-ийн Шударга Тоглоомын Нөхцөлийг зөрчсөний улмаас таны бүртгэлийг хориглосон.",
    accountIdRequired: "Хэрэглэгчийн нэрээ оруулна уу'",
    passwordStrengthError: "Нууц үгээ өөрөө үүсгэ. Нууц үг нь 8-10 тэмдэгтээс бүрдэх ба тоо үсэгний хослол байх ёстой.'",
    session_expired: "Сесс дууссан'",
    sessionExpired: "Сесс дууссан'",

    app_id_required: "Хэрэглээний ID шаардлагатай",
    permission_denied: "Зөвшөөрөл татгалзлаа",
    account_id_required: "Хэрэглэгчийн нэр/Бүртгэлийн ID шаардлагатай",
    verification_code_required: "Баталгаажуулах код шаардлагатай",
    account_not_exists: "Хэрэглэгчийн нэр/акаунт байхгүй",
    account_inactive: "Хэрэглэгчийн нэр/Бүртгэл идэвхгүй байна",
    verify_failed: "Баталгаажуулах үйл явц амжилтгүй болсон",
    parent_account_inactive: "Эцэг эхийн бүртгэл идэвхгүй байна",
    transfer_id_required: "Шилжүүлгийн ID шаардлагатай",
    credit_amount_required: "Кредит хэмжээ шаардлагатай",
    duplicate_credit_record: "Давхардсан кредит бүртгэл",
    member_wallet_not_exists: "Гишүүн түрийвч байхгүй",
    debit_amount_required: "Дебитийн дүн шаардлагатай",
    duplicate_debit_record: "Давхардсан дебит бүртгэл",
    insufficient_balance: "Боломжит үлдэгдэл хангалтгүй",
    result_exists: "Үр дүнгийн бүртгэл байгаа",
    debit_record_not_found: "Дебит бүртгэл олдсонгүй",
    bank_id_required: "Банкны ID шаардлагатай",
    bank_acc_no_required: "Банкны дансны дугаар шаардлагатай",
    bank_acc_holder_required: "Банкны данс эзэмшигчийн нэр шаардлагатай",
    bank_already_setup: "Банкны данс аль хэдийн тохируулагдсан",
    platform_required: "Платформ шаардлагатай",
    parent_not_exists: "Эцэг эх байхгүй",
    invalid_password: "Нууц үг буруу байна",
    invalidPassword: "Нууц үг буруу байна",
    parent_id_required: "Эцэг эхийн үнэмлэх шаардлагатай",
    password_required: "Нууц үг шаардлагатай",
    contact_phone_required: "Холбоо барих утасны дугаар шаардлагатай",
    account_exists: "Хэрэглэгч/Бүртгэлийн ID аль хэдийн байна",
    vip_mode_not_exists: "VIP горим байхгүй",
    session_not_exists: "Таны сессийн хугацаа дууссан тул дахин нэвтэрнэ үү.",
    ticket_id_required: "Тасалбарын ID шаардлагатай",
    ref_id_required: "Лавлах ID шаардлагатай",
    ticket_not_exists: "Тасалбар байхгүй",
    ticket_processed: "Тасалбарыг аль хэдийн боловсруулсан",
    min_deposit_not_met: "Депосит хэмжээ хамгийн бага дүнтэй тэнцүү байх ёстой",
    ongoing_promotion: "Танд урамшуулал үргэлжилж байна. Дараа дахин нэхэмжлэнэ үү",
    invalid_promo_package: "Хүчингүй урамшууллын багц",
    promo_min_deposit_not_met: "Депосит хэмжээ урамшууллын доод хэмжээнд хүрэхгүй байна",
    claim_promo_only_once_a_day: "Урамшуулалыг өдөрт нэг л удаа нэхэмжилж болно",
    first_deposit_unmet: "Өдөр тутмын эхний депосит урамшууллыг нэхэмжилж байна.",
    newbie_unmet: "Шинэхэн депосит шагнал олгогдсон",
    claim_promo_only_once: "Урамшуулалыг зөвхөн нэг удаа авч болно",
    inner_catch: "Гэнэтийн алдаа",
    systemError: "Системийн алдаа",
    deposit_amount_required: "Депосит хэмжээ шаардлагатай",
    target_bank_id_required: "Зорилтот банкны ID шаардлагатай",
    target_bank_acc_no_required: "Зорилтот банкны дансны дугаар шаардлагатай",
    target_bank_acc_holder_required: "Зорилтот банкны данс эзэмшигчийн нэр шаардлагатай",
    deposit_date_required: "депосит огноо шаардлагатай",
    deposit_method_required: "Депосит арга шаардлагатай",
    min_deposit_not_set: "Депосит доод хэмжээг тогтоогоогүй",
    min_balance_not_set: "Боломжит хамгийн бага үлдэгдэл тогтоогдоогүй",
    ibank_account_not_exists: "IBANK88 данс байхгүй",
    ibank_account_inactive: "IBANK88 данс идэвхгүй байна",
    withdrawal_amount_required: "Татан авалтын дүн шаардлагатай",
    min_withdrawal_not_set: "Татан авалтын доод хэмжээг тогтоогоогүй",
    bank_member_not_exists: "Зорилтот гишүүн банкны данс байхгүй байна",
    promotion_requirement_not_met: "Та үргэлжилсэн урамшуулал хэвээр байна",
    invalid_promotion: "Хүчингүй урамшуулал",
    new_password_required: "Шинэ нууц үг шаардлагатай",
    multiplier_not_found: "Систем таны хүсэлтийг одоогоор боловсруулах боломжгүй байна дараа дахин оролдоно уу.",
    contact_phone_exists: "Энэ утас аль хэдийн бүртгэгдсэн",
    BLOCK: "Таны бүртгэл хаагдсан байна",
    tac_is_valid: "Таны өмнөх taк код хүчинтэй хэвээр байна",
    tac_expired: "Таны taк кодын хугацаа дууссан. Шинэ tac код асууна уу",
    tacExpired: "Таны taк кодын хугацаа дууссан. Шинэ tac код асууна уу",
    invalid_tac: "Так код буруу",
    invalidTac: "Так код буруу",
    tac_not_validate: "Так код хараахан батлагдаагүй байна",
    tacCodeRequired: "Так кодыг оруулна уу",
    invalidPhone: "Утасны дугаар буруу",
    invalid_referral_code: "Хүчингүй лавлагаа код",
    exceed_max_withdrawal: "Татан авалтын дээд хэмжээнээс хэтэрсэн",
    bank_member_inactive: "Хэрэглэгчийн банк идэвхгүй байна",
    loginFailed: "Нэвтэрч чадсангүй",
    loginSucceed: "Амжилттай нэвтэрлээ",
    usernameRequired: "Хэрэглэгчийн нэрээ оруулна уу",
    passwordRequired: "Нууц үгээ оруулна уу",
    logoutSucceed: "Амжилттай гарлаа",
    logoutFailed: "Гарч чадсангүй",
    requestSucceed: "Хүсэлт амжилт",
    requestFailed: "Хүсэлт амжилтгүй болсон",
    requestProcessing: "Таны хүсэлтийг одоогоор боловсруулж байна",
    requestDelayed: "Хүсэлтийг хойшлуулах",
    verificationCodeRequired: "Баталгаажуулах TAC код шаардлагатай",
    newPasswordRequired: "Шинэ нууц үг шаардлагатай",
    bankIdRequired: "Банк сонгоно уу",
    bankNameRequired: "Банкны нэр шаардлагатай",
    bankAccHolderRequired: "Банкны данс эзэмшигчийн нэр шаардлагатай",
    bankAccNoRequired: "Банкны дансны дугаар шаардлагатай",
    depositAmountRequired: "Депосит дүнг оруулна уу",
    dateRequired: "Огноо сонгоно уу",
    bonusIdRequired: "Бэлгийг сонгож авна уу",
    bank_member_exists: "Банкны данс аль хэдийн бүртгүүлсэн",
    never_deposited: "Найзууд руугаа мөнгө шилжүүлэхийн өмнө та дор хаяж нэг депосит хийх ёстой.",
    transferAmountMustGreaterThanEqual5: "Шилжүүлгийн дүн 5 IDR-ээс их буюу тэнцүү байх ёстой",
    invalid_transfer_amount: "Шилжүүлгийн дүн 5 IDR-ээс их буюу тэнцүү байх ёстой",
    // account_not_exists: "Данс байхгүй байна",
    ongoing_promotion: "Танд  үргэлжилсэн урамшуулал хэвээр байна",
    insufficient_balance: "Үлдэгдэл хангалтгүй",
    insufficientBalance: "Үлдэгдэл хангалтгүй",
    transfer_success: "Амжилттай шилжүүллээ",
    sender_id_required: "Илгээгчийн ID шаардлагатай",
    recipient_id_required: "Хүлээн авагчийн ID шаардлагатай",
    tac_validated: "TAC кодыг баталгаажуулсан. Дахин хүсэлт гаргана уу",
    pending_result_in_game: "Тоглолтын хүлээгдэж буй үр дүн",
    accountIdOnlyNumber: "Зөвхөн хүчинтэй утасны дугаар",
    unfinishgamedetected: "Энэ үйлдлийг үргэлжлүүлэхийн өмнө үнэгүй тоглоомоо дуусгана уу.",
    duplicate_review: "Та өмнө нь шүүмж илгээсэн",
    exceed_withdrawal_frequency: "Та мөнгө авах өдрийн хязгаараас хэтэрсэн байна.(өдөрт 5 удаа)",
    requestTooFrequentAtLeast2Minutes: "Таны хүсэлтийг боловсруулж байна",
    invalidPhoneNumberFormat: "Утасны дугаарын формат буруу",
    fpayUnderMaintenance: "Системийн засвар үйлчилгээ",
    affiliate_not_exists: "Түншлэл байхгүй",
    phoneRequired: "Утасны дугаараа оруулна уу'",
    couponeCodeRequired: "Купон код шаардлагатай",
    coupon_code_required: "Купон код шаардлагатай",
    coupon_not_available: "Купон код боломжгүй",
    contact_email_registered: "Имэйл аль хэдийн байна",
    invalidEmailFormat: "Буруу имэйл формат",
    emailRequired: "Имэйл шаардлагатай",
    paymentMethodRequired: "Төлбөрийн аргыг сонгоно уу",
    depositMethodRequired: "Депосит аргыг сонгоно уу",
    no_changes: "Банк өгөгдөл  өөрчлөгдөөгүй",
    resultIdRequired: "Үр дүнгийн ID шаардлагатай",
    free_credit_detected: "Тоглох мөнгө",

    //new
    amount_required: "Шаардлагатай хэмжээ",
    auth_token_required: "Сессын токен шаардлагатай",
    bet_id_required: "Бооцооны дугаар шаардлагатай",
    bonus_unavailable: "Бонус авах боломжгүй",
    client_ip_required: "Үйлчлүүлэгчийн IP шаардлагатай",
    first_deposit_not_met: "Эхний депосит шаардлагатай",
    ftd_required: "Эхний депосит шаардлагатай",
    game_maintenance: "Одоогоор засвар үйлчилгээ хийж байгаа тул дараа дахин оролдоно уу.",
    gateway_acc_required: "Gateway данс шаардлагатай",
    inbox_id_required: "Ирсэн имэйлийн ID шаардлагатай",
    insufficient_rebate: "Хөнгөлөлт хангалтгүй",
    insufficient_ticket: "Тасалбар хангалтгүй",
    is_default_required: "үндсэн сонголт шаардлагатай",
    min_withdrawal_not_met: "Татан авалтын доод хэмжээ хангагдаагүй",
    newbie_not_met: "Шинэхэн танилцаагүй",
    no_changes: "Банкны горим өөрчлөгдөөгүй",
    promotion_not_available: "Урамшуулал байхгүй",
    ref_no_required: "Лавлах дугаар шаардлагатай",
    result_id_required: "Үр дүнгийн ID шаардлагатай",
    search_id_required: "Хайлтын ID шаардлагатай",
    setting_not_set: "Тохиргоо дугаар",
    tac_required: "Так код шаардлагатай",
    ticket_count_required: "Шаардлагатай тасалбарын хэмжээ",
    vip_not_exists: "VIP гишүүн биш",
    working_date_required: "Ажлын огноо шаардлагатай",
    working_month_required: "Ажлын сар шаардлагатай",
    withdrawal_amount_lte_withhold_amount: "Суутгасан дүнгээс бага буюу тэнцүү хэмжээний мөнгө авах.",
    providerRequired: "Үйлчилгээ үзүүлэгч шаардлагатай",
    invalid_contact_email: "Хүчингүй и-мэйл",
    invalidUsernameFormat: "Хэрэглэгчийн нэр буруу формат",
    secondaryAccountExists: "Хоёрдогч данс байна",

    accountInactive: "Бүртгэл идэвхгүй",
    permissionDenied: "Зөвшөөрөл  татгалцлаа",
    amountRequired: "Шаардлагатай хэмжээ",
    ipAddressRequired: "Шаардлагатай IP хаяг",
    transactionIdRequired: "Гүйлгээний ID шаардлагатай",
    parentIdRequired: "Эцэг эхийн үнэмлэх шаардлагатай",
    auditByRequired: "Шаардлагатай бол аудит хийх",
    systemTypeRequired: "Системийн төрөл шаардлагатай",
    currencyRequired: "Валют шаардлагатай",
    loginIdRequired: "Нэвтрэх ID шаардлагатай",
    profileIdRequired: "Профайлын ID шаардлагатай",
    authTokenRequired: "Хүчингүй сессийн токен",
    promotionIdRequired: "урамшуулалын ID шаардлагатай",
    promotionNameRequired: "Урамшуулалын нэр шаардлагатай",
    minDepositRequired: "Хамгийн бага депосит шаардлагатай",
    transferIdRequired: "Шилжүүлгийн ID шаардлагатай",
    betIdRequired: "Бооцооны ID шаардлагатай",
    accountExists: "Бүртгэл байна",
    invalidSystemType: "Хүчингүй системийн төрөл",
    accountNotExists: "Бүртгэл байхгүй",
    invalidStatus: "Хүчингүй төлөв",
    samePassword: "Шинэ нууц үг хуучин нууц үгтэй ижил байж болохгүй",
    invalidAmount: "Буруу дүн",
    pendingResultInGame: "Тоглоомын хүлээгдэж буй үр дүн",
    invalidSession: "Хүчингүй сесс",
    promotionExists: "Урамшуулал байгаа",
    promotionNotExists: "Урамшуулал байхгүй",
    currencyNotSupported: "Валютыг дэмждэггүй",
    minimumDepositNotMeet: "Депоситийн  доод хэмжээ хангагдаагүй",
    promotionInactive: "Урамшуулал идэвхгүй",
    unableToLaunchSlotGameAtTheMoment: "Одоогоор тоглоомыг эхлүүлэх боломжгүй байна дараа дахин оролдоно уу.",
    "Game Is Disable": "Тоглоом идэвхгүй",
    undefined: "Холболтоо шалгаад дахин оролдоно уу.",
    invalidLogin: "Хэрэглэгчийн нэр/нууц үг буруу",
    invalidToken: "Сессийн хугацаа дууссан. Дахин нэвтэрнэ үү",
    rebateOngoing: "Хөнгөлөлт үргэлжилж байна.",
    technicalError: "Техникийн алдаа. Админтай  холбогдоно уу.",
    unknownError: "Техникийн алдаа. Админтай холбогдоно уу.",
    tacNotExpired: "TAC кодын хугацаа дуусаагүй байна. Дараа дахин оролдоно уу.",
    contactPhoneRequired: "Холбоо барих утасны дугаар шаардлагатай",
    invalidPhoneFormat: "Утасны формат буруу байна. Дараа дахин оролдож үзнэ үү.",
    invalidAccountName: "Дансны нэр буруу",
    insufficientFund: "Санхүүжилт хангалтгүй",
    invalidIDContact: "Нууц үгээ сэргээж чадсангүй.",
    accountIDLowerMinCharacter: "Бүртгэлийн ID хамгийн бага тэмдэгтээс бага.",
    phoneExists: "Холбоо барих дугаар байна",
    invalidMember: "Хэрэглэгчийн нэр/нууц үг буруу",
    parentInvalid: "Хүчингүй Агент ID",
  },

  newpw_required: "Шинэ нууц үг оруулна уу",
  newpw_notsame: "Шинэ нууц үг нь одоогийн нууц үгтэй ижил байж болохгүй",
  newpw_alphanumeric: "Шинэ нууц үг үсэг тооны хослол байх ёстой",

  oldpw_required: "Одоогийн нууц үгээ оруулна уу.",

  pw_notmatched: "Нууц үг шинэ нууц үгтэй таарахгүй байгааг баталгаажуулах",

  forgot_password_success: "Нууц үг амжилттай шинэчлэгдсэн!!",
  add_bank_success: "Шинэ банкны данс амжилттай нэмэгдсэн!!",
  set_default_success: "Анхдагчаар амжилттай тохирууллаа!!",
  update_success: "Амжилттай шинэчлэгдсэн",

  tac_tooltips: "TAC кодыг таны холбоо барих дугаар руу илгээсэн.",
  tac_tooltips: '1Шинэ tac код авахын тулд "Дахин илгээх" дээр дарна уу',
  tac_countdown: "{Countdown}  дахин илгээнэ үү",

  bank_details_tooltips: "Хэрэв таны банкны дансны нэр UBWIN-д бүртгүүлсэн овог нэрээсээ өөр бол таны мөнгө авах гүйлгээ татгалзах болно.",
  copy_clipboard: "Холбоосыг хуулсан",

  wrong_filetype: "Файлын төрөл буруу",
  deposit_confirm: "Та үнэхээр мөнгө байршуулахыг хүсэж байна уу?",
  deposit_cancel: "Депосит амжилтгүй боллоо.",
  deposit_success: "Депосит амжилттай!",

  upload_cancel: "Хавсралтыг байршуулж чадсангүй.",
  upload_success: "Хавсралтыг амжилттай байршууллаа!",
  upload_missing: "Хавсралт байхгүй байна!",

  password_success: "Нууц үг амжилттай шинэчлэгдсэн!!",

  addbank_success: "Банк амжилттай нэмэгдсэн",
  addbank_cancel: "Банк нэмж чадсангүй",

  withdraw_success: "Татан авалтын тасалбарыг амжилттай илгээх",
  withdraw_cancel: "Татан авалтын тасалбар илгээж чадсангүй",

  rebate_success: "Хөнгөлөлтийг амжилттай нэхэмжилсэн",
  transfer_success: "Гишүүнийг амжилттай шилжүүллээ",
  addmember_success: "Шинэ гишүүн амжилттай бүртгүүллээ",

  refNoRequired: "Ref дугаар  шаардлагатай",
  attachmentPathRequired: "Хавсралт шаардлагатай",
  disconnect: "Холболтоо шалгаад дахин оролдоно уу.",

  insufficientBalance: "Үлдэгдэл хангалтгүй",
  insufficientFund: "Санхүүжилт хангалтгүй",
  amountRequired: "Шаардлагатай хэмжээ",
  
};
